import { useEffect, useState } from "react";
import { useBffClient } from "../../../hooks/use-bff-client";
import { useFrontendContext } from "../../../hooks/use-frontend-context";
import { useSearchParams } from "@remix-run/react";
import { ISbStoryData } from "@storyblok/js";

export interface BlogList {
  stories: ISbStoryData[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
  tags: { name: string; taggings_count: number }[];
}

export const useBlogList = () => {
  const frontendContext = useFrontendContext();
  const [searchParams] = useSearchParams();
  const bffClient = useBffClient();
  const [blogList, setBlogList] = useState<BlogList | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const page = searchParams.get("page") ?? "1";
  const tag = searchParams.get("tag") ?? "";

  useEffect(() => {
    const fetchBlogList = async () => {
      try {
        const response = await bffClient.request<BlogList>(
          `v1/storyblok-stories/by-folder/${frontendContext.siteSlug}?${new URLSearchParams(
            {
              folder: "blog",
              page,
              tag,
            },
          )}`,
          new Headers(),
          "GET",
        );
        setBlogList(response);
      } catch (err) {
        setError(err as Error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBlogList();
  }, [page, tag]);

  return { blogList, isLoading, error };
};
